import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index.js'
import { isObject, getStorage } from '@/utils/util.js'
import { TokenFlagInStorage } from '@/config/config.js'

Vue.use(VueRouter)

VueRouter.prototype.$parseRoute = function(routeOption) {
  const route = {
    ...routeOption
  }
  route['component'] = () => import(`@/views/${routeOption['component']}`)
  if (routeOption['children'] !== undefined && routeOption['children'] !== null && routeOption['children'].length > 0) {
    const children = []
    for (const childrenItem of routeOption['children']) {
      children.push(this._parserRoute(childrenItem))
    }
  }
  return route
}

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login/index.vue'),
  },
  {
    path: '/forgetPassword',
    name: 'forgetPassword',
    component: () => import('@/views/ForgetPassword/index.vue'),
  },
  {
    path: '/',
    name: 'root',
    component: () => import('@/views/Layout/index.vue'),
    children: [
      {
        path: '/agentDetail',
        name: 'agentDetail',
        component: () => import('@/views/Agent/detail.vue'),
      },
      {
        path: '/campaignDetail',
        name: 'campaignDetail',
        component: () => import('@/views/Campaign/detail.vue'),
      },
      {
        path: '/onSaleProductDetail',
        name: 'onSaleProductDetail',
        component: () => import('@/views/OnSaleProduct/detail.vue'),
      },
      {
        path: '/produceOrderDetail',
        name: 'produceOrderDetail',
        component: () => import('@/views/ProduceOrder/detail.vue'),
      },
      {
        path: '/purchaseOrderDetail',
        name: 'purchaseOrderDetail',
        component: () => import('@/views/PurchaseOrder/detail.vue'),
      },
      {
        path: '/saleOrderDetail',
        name: 'saleOrderDetail',
        component: () => import('@/views/SaleOrder/detail.vue'),
      },
      {
        path: '/stockChangeDetail',
        name: 'stockChangeDetail',
        component: () => import('@/views/StockChange/detail.vue'),
      },
      {
        path: '/activeCodeOrderDetail',
        name: 'activeCodeOrderDetail',
        component: () => import('@/views/ActiveCodeOrder/detail.vue'),
      },
      {
        path: '/insiteMessage',
        name: 'insiteMessage',
        component: () => import('@/views/InsiteMessage/index.vue'),
      },
      {
        path: '/404',
        name: '404',
        component: () => import('@/views/404/index.vue'),
      },
      // 新统计页面子路由
      {
        path: '/statistics/totalUserCount',
        name: 'totalUserCount',
        component: () => import('@/views/Statistics/TotalUserCount/index.vue'),
      },
      {
        path: '/statistics/totalAgentCount',
        name: 'totalAgentCount',
        component: () => import('@/views/Statistics/TotalAgentCount/index.vue'),
      },
      {
        path: '/statistics/totalSaleCount',
        name: 'totalSaleCount',
        component: () => import('@/views/Statistics/TotalSaleCount/index.vue'),
      },
      {
        path: '/statistics/totalPurchaseCount',
        name: 'totalPurchaseCount',
        component: () => import('@/views/Statistics/TotalPurchaseCount/index.vue'),
      },
      {
        path: '/statistics/totalActiveCount',
        name: 'totalActiveCount',
        component: () => import('@/views/Statistics/TotalActiveCount/index.vue'),
      },
      {
        path: '/statistics/totalBindCount',
        name: 'totalBindCount',
        component: () => import('@/views/Statistics/TotalBindCount/index.vue'),
      },
      {
        path: '/statistics/totalStoreCount',
        name: 'totalStoreCount',
        component: () => import('@/views/Statistics/TotalStoreCount/index.vue'),
      },
      {
        path: '/statistics/totalAfterSaleCount',
        name: 'totalAfterSaleCount',
        component: () => import('@/views/Statistics/TotalAfteSraleCount/index.vue'),
      },
      {
        path: '/statistics/productActiveRank',
        name: 'productActiveRank',
        component: () => import('@/views/Statistics/ProductActiveRank/index.vue'),
      },
      {
        path: '/statistics/totalUserCount/child',
        name: 'childUserCount',
        component: () => import('@/views/Statistics/TotalUserCount/ChildUserCount/index.vue'),
      },
      {
        path: '/statistics/totalSaleCount/detail',
        name: 'saleDetails',
        component: () => import('@/views/Statistics/TotalSaleCount/SaleDetails.vue'),
      },
      {
        path: '/statistics/totalAgentCount/child',
        name: 'childAgentCount',
        component: () => import('@/views/Statistics/TotalAgentCount/ChildAgentCount/index.vue'),
      },
      {
        path: '/statistics/activeDetail',
        name: 'activeDetail',
        component: () => import('@/views/Statistics/TotalActiveCount/childActive.vue'),
      },
      {
        path: '/statistics/bindDetail',
        name: 'bindDetail',
        component: () => import('@/views/Statistics/TotalBindCount/childBind.vue'),
      },
      {
        path: '/statistics/storeDetail',
        name: 'storeDetail',
        component: () => import('@/views/Statistics/TotalStoreCount/storeDetail.vue'),
      },
      {
        path: '/statistics/childAfteSale',
        name: 'childAfteSale',
        component: () => import('@/views/Statistics/TotalAfteSraleCount/childAfteSale.vue'),
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const whiteList = [
  '/login',
  '/forgetPassword',
]
router.beforeEach(async (to, from, next) => {
  if (whiteList.indexOf(to.path) > -1) {
    next()
    return
  }
  // 是否存在登录
  const authInfo = getStorage(TokenFlagInStorage)
  if (!isObject(authInfo)) {
    console.log('未登录')
    next({
      path: '/login',
      replace: true,
    })
    return
  }
  const expireTime = authInfo['expire_time'] || 0
  if (expireTime - 60000 < new Date().getTime()) {
    console.log('登录过期')
    next({
      path: '/login',
      replace: true,
    })
    return
  }
  if (!store.state.isInitUserRoutes) {
    store.dispatch({
      type: 'initUser',
      success: (routes) => {
        // 插入路由
        for (const route of routes) {
          router.addRoute('root', router.$parseRoute(route))
        }
        next({
          path: to.path,
          query: to.query,
          replace: true,
        })
      },
      fail: () => {
        next({
          path: '/login',
          replace: true,
        })
      },
    })
  } else {
    next()
  }
})

export default router
